import TextField from "@material-ui/core/TextField";
import React, { useState, useEffect } from "react";
import Popover from "@mui/material/Popover";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRange, ArrowLeft, ArrowRight } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import Calendar from './Calendar'
// import "./index.css";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  input: {
    color: "#333333",
    cssUnderline: {
      "&:after": {
        borderBottomColor: "#333333",
      },
    },
    cssLabel: {
      "&$cssFocused": {
        color: "#333333",
      },
    },
  },
  textField:{
    fontSize:'1rem',
    fontWeight:400,
  },
  datePicker: {
    '& .MuiPickersModal-dialog': {
        backgroundColor: 'var(--dark) !important'
    },
    '& .MuiDialogActions-spacing ': {
      backgroundColor: 'var(--darker) !important'
  },
  '& .MuiDialogActions-spacing .MuiButton-label': {
    color:'var(--darker)'
},
'& .MuiTypography-root.MuiPickersYear-root.MuiTypography-subtitle1': {
  color:'var(--darker)'
},
'& .MuiTypography-root.MuiPickersYear-root.MuiPickersYear-yearSelected.MuiTypography-h5.MuiTypography-colorPrimary': {
  color:'var(--green)'
},

  '& .MuiPickersModal-dialog .MuiPickersBasePicker-container .MuiToolbar-root': {
    backgroundColor: 'var(--darker)  !important'
},
'& .MuiToolbar-root.MuiToolbar-regular.MuiPickersToolbar-toolbar.MuiPickersDatePickerRoot-toolbar.MuiToolbar-gutters': {
  backgroundColor: 'var(--green)  !important'
},
'& .MuiPickersBasePicker-container .MuiPickersBasePicker-pickerView .MuiPickersDay-day ':{
color:'var(--darker)'
},
'& .MuiPickersBasePicker-container .MuiButtonBase-root.MuiIconButton-root.MuiPickersDay-day.MuiPickersDay-dayDisabled ':{
  color:'var(--backgroundcolor)'
  },

'& .MuiPickersBasePicker-container .MuiPickersCalendarHeader-iconButton ':{
  color:'var(--darker)',
  backgroundColor:'var(--white)',
  padding:'7px',
  margin:'0px 5px'
  }
,
'& .MuiPickersBasePicker-container .MuiPickersDay-daySelected':{

  backgroundColor:'var(--green)',
 
  }
,
'& .MuiPickersCalendarHeader-switchHeader p,.MuiTypography-root.MuiPickersCalendarHeader-dayLabel.MuiTypography-caption':{
  color:'var(--darker) '
  
}
  }
}));

export default function BasicDateRangePicker(props) {
  const classes = useStyles();
  const [showEndDate, setShowEndDate] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
 

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

 
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  

  const handleStartChange = (val) => {
    

    if (props.onStartChange) 
    props.onStartChange(val);
  };

  const handleEndChange = (val) => {
    if (props.onEndChange) 
    props.onEndChange(val);
  };



  const handleDateChange=(data)=>{
    if(data.length)
    {
      handleStartChange(data[0]);
      handleEndChange(data[1]);
      
    setAnchorEl(null);
    }
  }
  

  const onUpdate = (key, button) => {
    let { start, end } = props.value;
    if (start && key == "startDate") {
      if (button == "next") {
        start = moment(start).add(1, "day");
      } else if (button == "prev") {
        start = moment(start).subtract(1, "day");
      }
    } else if (end && key == "endDate") {
      if (button == "next") {
        end = moment(end).add(1, "day");
      } else if (button == "prev") {
        end = moment(end).subtract(1, "day");
      }
    }
    start&&  handleStartChange(start.toDate());
    end&& handleEndChange(end.toDate());
  };

  let value = props.value;

  return (
    <div
      className="box mydatepicker"
      style={{ margin: 3, backgroundColor: "var(--backgroundcolor)",padding:'2px' }}
    >
       
          <div  >
            <div onClick={handleClick} style={{ display: "inline-block", width: "6%" }}>
              <DateRange style={{ color: "var(--darker)" }} />
            </div>
            <div className="inline-block" style={{ width: "42%",marginLeft:'10px'  }}>
              <div className="inline-block" style={{ width: "63%" }}  onClick={handleClick}>
                <TextField
                  type="text"
                  style={{ width: "100px", color: "var(--darker)" ,
                  padding:'1px 0px'}}
                  inputProps={{classes:classes.textField}}
                  placeholder="Check In Date"
                  value={
                    value.start
                      ? value.start
                        ? moment(value.start).format("DD/MM/YYYY")
                        : ""
                      : ""
                  }
                />
              </div>

              <div style={{ display: "inline-block", width: "37%" }}>
                <a>
                  <ArrowLeft
                    className="arrow"
                    onClick={() => onUpdate("startDate", "prev")}
                  />
                </a>
                <a>
                  <ArrowRight
                    className="arrow"
                    onClick={() => onUpdate("startDate", "next")}
                  />
                </a>
              </div>
            </div>

            <div
              style={{
                display: "inline-block",
                width: "2px",
                margin: "5px",
                height: 28,
                verticalAlign: "middle",
                backgroundColor: "var(--darker)",
              }}
            ></div>

            <div className="inline-block" style={{ width: "44%" }}>
              <div
                className="inline-block"
                style={{  width: "57%" }}  onClick={handleClick}
              >
                <TextField
                  type="text"
                  style={{ width: "106px", color: "var(--darker)",
                 padding:'1px 0px' }}
                  inputProps={{classes:classes.textField}}
                  placeholder="Check Out Date"
                  value={value.end ? moment(value.end).format("DD/MM/YYYY") : ""}
                />
              </div>
              <div className="inline-block" style={{ width: "36%",marginLeft:'10px' }}>
                <a>
                  <ArrowLeft
                    className="arrow"
                    onClick={() => onUpdate("endDate", "prev")}
                  />
                </a>
                <a>
                  <ArrowRight
                    className="arrow"
                    onClick={() => onUpdate("endDate", "next")}
                  />
                </a>
              </div>
            </div>
          </div>
      
      

        <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      > 
   
      <div style={{backgroundColor:'var(--backgroundcolor)',borderRadius:'5px'}}>
                    <Calendar onChange={handleDateChange} 
                    value={[value.start,value.end]}
                     />
                 </div>
      </Popover>
    </div>
  );
}
